/** ***************************************************************

IMPORTANT!
Any changes made here must be made in routes.production
These files should be almost identical. They should only differ by
which routes are async.

**************************************************************** */

import React from 'react'
import { Route, Redirect } from 'react-router'
import { get } from 'lodash'

// Routes which are always sync
import AppAuthed from 'pages/AppAuthed'
import AppUnAuthed from 'pages/AppUnAuthed'
import AppRoot from 'pages/AppRoot'
import Dashboard from 'pages/Dashboard'
import { CallAnalyticsContainer } from 'pages/CallAnalytics'
import NotFound from 'pages/NotFound'
import Login from 'pages/Login'
import PasswordReset from 'pages/PasswordReset'
import JoinAccount from 'pages/JoinAccount'
import Settings from 'pages/Settings'
import { Contacts } from 'pages/Contacts'
import { ContactPage } from 'pages/Contact'
import BlogIndex from 'pages/BlogIndex'
import BlogArticle from 'pages/BlogArticle'
import Cases from 'pages/Cases'
import { BillingBills } from 'pages/BillingBills'
import BillingAccount from 'pages/BillingAccount'
import { BillingPayments } from 'pages/BillingPayments'
import BillingAccounts from 'pages/BillingAccounts'
import Numbers from 'pages/Numbers'
import NumbersEdit from 'pages/NumbersEdit'
import NumberCalls from 'pages/NumberCalls'
import { Internet } from 'pages/Internet'
import { InternetService } from 'pages/InternetService'
import { PhoneLines } from 'pages/PhoneLines'
import { PhoneLine } from 'pages/PhoneLine'
import PhoneSystemsEdit from 'pages/Services/HostedVoice/PhoneSystemsEdit'
import Flows from 'pages/Flows'
import FlowLogs from 'pages/FlowLogs'
import FlowLog from 'pages/FlowLog'
import Flow from 'pages/Flow'
import Admin from 'pages/Admin'
import AdminUsers from 'pages/AdminUsers'
import { RecordingsPage } from 'pages/Recordings'
import { RecordingPage } from 'pages/Recording'
import { VoicesPage } from 'pages/Voices'
import { VoicePage } from 'pages/Voice'
import { WholesalerPortal } from 'pages/WholesalerPortal'
import { MessageThreadPageContainer } from 'pages/MessageThread'
import CmsPage from 'features/Cms/CmsPage'
import { closeAll } from 'features/Modal/Modal.actions'
import HostedVoice from 'pages/Services/HostedVoice'
import PhoneSystems from 'pages/Services/HostedVoice/PhoneSystems'

export default store => {
  const routeChange = () => {
    // Close all modals if they exist
    if (store.getState().modal.stack.length > 0) {
      store.dispatch(closeAll())
    }
  }

  if (
    window.location.hostname.includes('thinkpickle.com.au') ||
    window.location.hostname.includes('localhost')
  ) {
    return (
      <Route component={AppRoot} onChange={routeChange}>
        <Route component={AppUnAuthed}>
          <Route path="login" component={Login} />
        </Route>
        <Route path="join" component={JoinAccount} />
        <Route component={AppAuthed}>
          <Route path="dashboard" component={Dashboard} />
          <Route path="dashboard/voice-actor-recordings" component={VoicesPage} />
          <Route path="dashboard/voice-actor-recordings/:voiceId" component={VoicePage} />
          <Route path="dashboard/recordings" component={RecordingsPage} />
          <Route path="dashboard/recordings/:recordingId" component={RecordingPage} />
          <Route path="dashboard/contacts" component={Contacts} />
          <Route path="dashboard/contacts/:contactId" component={ContactPage} />
          <Route path="dashboard/analytics" component={CallAnalyticsContainer} />
          <Route path="dashboard/messages" component={MessageThreadPageContainer} />
          <Route path="dashboard/messages/:serviceId" component={MessageThreadPageContainer} />
          <Route
            path="dashboard/messages/:serviceId/:otherNumber"
            component={MessageThreadPageContainer}
          />
          <Route path="dashboard/numbers" component={Numbers} />
          <Route path="dashboard/numbers/:serviceId" component={NumbersEdit}>
            <Route path="calls" component={NumberCalls} />
          </Route>

          <Route path="dashboard/hosted-voice" component={HostedVoice} />
          <Route path="dashboard/hosted-voice/phone-systems" component={PhoneSystems} />
          <Route path="dashboard/hosted-voice/phone-systems/:phoneSystemId" component={PhoneSystemsEdit} />
          <Route path="dashboard/hosted-voice/:serviceId" component={NumbersEdit}>
            <Route path="calls" component={NumberCalls} />
          </Route>

          <Route path="dashboard/internet" component={Internet} />
          <Route path="dashboard/internet/:serviceId" component={InternetService}>
            <Route path="usage" component={NumberCalls} />
          </Route>
          <Route path="dashboard/phone-lines" component={PhoneLines} />
          <Route path="dashboard/phone-lines/:serviceId" component={PhoneLine}>
            <Route path="usage" component={NumberCalls} />
          </Route>
          <Route path="dashboard/flows" component={Flows} />
          <Route path="dashboard/flows/:flowId" component={Flow} />
          <Route path="dashboard/flows/:flowId/logs" component={FlowLogs} />
          <Route path="dashboard/flows/:flowId/logs/:flowLogId" component={FlowLog} />
          <Route path="dashboard/settings" component={Settings} />
          <Route path="dashboard/billing" component={BillingBills} />
          <Route path="dashboard/billing/accounts" component={BillingAccounts} />
          <Route path="dashboard/billing/accounts/:ban" component={BillingAccount} />
          <Route path="dashboard/billing/payments" component={BillingPayments} />
          <Route path="dashboard/cases" component={Cases} />
          <Route component={Admin}>
            <Route path="admin/users" component={AdminUsers} />
          </Route>
        </Route>
        <Route path="blog" component={BlogIndex} />
        <Route path="blog/:articleSlug" component={BlogArticle} />
        <Route path="password-reset" component={PasswordReset} />
        <Route path="404" component={NotFound} />
        <Route path="wholesale-portal" component={WholesalerPortal}>
          <Route path="analytics" component={CallAnalyticsContainer} />
        </Route>
        {store.getState().cms.page.map(page => {
          const path = get(page, 'fields.slug', '/')
          return <Route key={path} path={path} component={CmsPage} />
        })}
        {store.getState().cms.redirect.map((redirect, idx) => (
          <Redirect key={idx} from={get(redirect, 'fields.from')} to={get(redirect, 'fields.to')} />
        ))}
        <Redirect from="*" to="404" />
      </Route>
    )
  }
  return (
    <Route>
      <Route path="wholesale-portal" component={WholesalerPortal}>
        <Route path="analytics" component={CallAnalyticsContainer} />
      </Route>
      <Redirect from="*" to="wholesale-portal" />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./src/pages/routes.app.jsx